const PersonalSettings = () => import('@/modules/settings/views/PersonalSettings.vue')

export const personalSettingsRoutes = [
	{
		path: '/personal-settings',
		name: 'personalSettings',
		component: PersonalSettings
	}
]
